import SecureLS from "secure-ls";
import {has} from "lodash";

let securedLS: SecureLS;
let cache: Record<string, unknown> = {};

const LocalStorageWrapper = {
  getLocalStorage: function (): SecureLS {
    if (!securedLS) {
      securedLS = new SecureLS({encodingType: "aes"});
    }
    return securedLS;
  },

  get: function (key: string): unknown {
    if (has(cache, key)) {
      return cache[key];
    }

    const ls = this.getLocalStorage();

    let value = undefined;
    if (ls.getAllKeys().includes(key)) {
      try {
        value = ls.get(key);
      } catch (error) {
        console.error(`Failed to get value for key ${key}:`, error);
      }
    }

    cache[key] = value;
    return value;
  },

  set: function (key: string, value: unknown): void {
    const ls = this.getLocalStorage();
    ls.set(key, value);
    cache[key] = value;
  },

  remove: function (key: string): void {
    const ls = this.getLocalStorage();
    ls.remove(key);
    delete cache[key];
  },

  clear: function (): void {
    const ls = this.getLocalStorage();
    ls.clear();
    cache = {};
  },
};
export {LocalStorageWrapper};
